import { Box, Typography } from '@mui/material';
import Gift from '../../../assets/images/icons/gift_white.png';

const RegisterFooter = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#E1000C',
        width: '100%',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '80px',
        position: 'absolute',
        bottom: '0',
        left: '0',
      }}
    >
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <Typography
            sx={{ fontSize: '2rem', lineHeight: '1.75rem', fontWeight: '700', color: 'white' }}
          >
            สตาร์การ์ด คลับ 2026
          </Typography>
          <Box
            component={'img'}
            src={Gift}
            alt="Gift Icon"
            sx={{ width: '35px', marginTop: '-5px' }}
          />
        </Box>
        <Typography
          sx={{ fontSize: '1.25rem', lineHeight: '1.4rem', fontWeight: '500', color: 'white' }}
        >
          เปลี่ยนทุกลิตรเป็นคะแนน สะสมของรางวัลสุดคุ้ม
        </Typography>
      </Box>
    </Box>
  );
};

export default RegisterFooter;
